<button *ngIf="locked"
        class="lock-worklist-button se-button-no-ripple"
        [disabled]="!canUnlock"
        [disableRipple]="true"
        mat-icon-button
        matTooltipShowDelay="500"
        [matTooltip]="tooltip"
        (click)="invokeUnlockMethod($event)">
    <mat-icon class="worklist-lock-icon-font" fontSet="estensa-icons">icon_locked</mat-icon>
</button>
